import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, Container, Link, Modal, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiCheckCircle, mdiDrawPen, mdiSignature, mdiSignatureFreehand } from '@mdi/js';
import { Icon } from '@mdi/react';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemACK } from '../../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';



export const MemnbersEtcTakeNotePage = () => {
    const { idUser, data, menu, parameters, version, loading, notifications, displayName, RUT } = useGlobalState();
    useGlobalState();
    const { navigate } = useRouter();

    const [ACKs, setACKs] = useState<ItemACK[]>([]);
    const [ACK, setACK] = useState<ItemACK>();
    const [ACKSign, setACKSign] = useState<ItemACK>();


    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id === null) {
                setACK(undefined);
                handleGetACKs()
            }
            else {
                handleGetACK(parseInt(id));
                if (!ACKs || ACKs.length === 0) {
                    console.log(ACKs.length)
                    handleGetACKs()
                }
            }
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    const handleSignACK = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/acks/sign',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({ idACK: ACK.idACK })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data) {
                if (data.code === 0) {
                    window.location.hash = "#user/acks";
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleGetACK = async (idACK: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/acks/ack',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({ idACK: idACK })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data) {
                addNotificationStatus(data, setData);
                if (data.code === 0 && data.ACK) {
                    setACK(data.ACK)
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleGetACKs = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/acks/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    columns: "idACK, fechaACK, isActiveACK, isReadACK2, isSignACK2",
                    orderBy: "fechaACK", order: "desc",
                    isActiveACK: 1,
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data) {
                if (data.code === 0 && data.ACKs) {
                    setACKs(data.ACKs)
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        //handleGetACKs();
    }, [])
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Tomas de razón</Header>

                    {!!ACKs && (
                        <Table
                            header={<Header variant="h2" />}
                            stickyHeader
                            variant='embedded'
                            columnDefinitions={[
                                {
                                    id: 'ACK',
                                    header: 'Fecha de toma de razón',
                                    cell: (item) => <Link href={`#user/acks?id=${item.idACK}`}>{item.fechaACK}</Link>,
                                    width: 300,
                                },
                                {
                                    id: 'Firmada',
                                    header: 'Firmada',
                                    cell: (item) =>
                                        item.isSignACK.includes(idUser) ? (
                                            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                Firmada <Icon path={mdiSignatureFreehand} size={1} />
                                            </span>
                                        ) : (
                                            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                Pendiente de firma <Icon path={mdiSignature} color="red" size={1} />
                                            </span>
                                        ),
                                    width: 300,
                                },

                            ]}
                            items={ACKs}
                            loadingText="Loading ACKs..."
                        />
                    )}
                    {!!ACK && (
                        <Modal visible={!!ACK} header={`Toma de razón #${ACK.idACK}`} size='large' onDismiss={() => window.location.hash = "#user/acks"}
                            height={400}
                            footer={

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%",
                                    }}
                                >
                                    <Button variant="link" onClick={() => window.location.hash = "#user/acks"}>Cerrar</Button>
                                    {ACK.isSignACK.includes(idUser) ?
                                        <div><Header variant="h2"><Icon path={mdiDrawPen} size={1} /> Firmada <Icon path={mdiCheckCircle} color="green" size={1} /></Header></div>
                                        : <></>}

                                </div>

                            }
                        >
                            <Container>
                                <SpaceBetween size="m" direction="vertical">
                                    <div dangerouslySetInnerHTML={{ __html: ACK.ACK || "" }} />
                                    {!ACK.isSignACK.includes(idUser) ?
                                        <Box float="right">
                                            <Button variant="primary" onClick={() => handleSignACK()}>Firmar</Button>
                                        </Box> : null}
                                </SpaceBetween>
                            </Container>

                        </Modal>
                    )}
                </SpaceBetween>
            }
        />
    )
};
